module.exports = __webpack_public_path__ + "static/media/Ubicacion-Sepultura.44c46bc2.jpg";